import { Component, Directive, EventEmitter, inject, Input, OnDestroy, OnInit, Output, QueryList, ViewChildren } from '@angular/core';
import { Auth, onAuthStateChanged } from '@angular/fire/auth';
import { Observable, Subscription } from 'rxjs';
import { Navigation } from 'src/app/enums/navigation.enum';
import { Entry } from 'src/app/models/entry';
import { EntryService } from 'src/app/services/entry.service';

export type SortColumn = keyof Entry | '';
export type SortDirection = 'asc' | 'desc' | '';
const rotate: {[key: string]: SortDirection} = { 'asc': 'desc', 'desc': '', '': 'asc' };

const compare = (v1: string | number, v2: string | number) => v1 < v2 ? -1 : v1 > v2 ? 1 : 0;

export interface SortEvent {
  column: SortColumn;
  direction: SortDirection;
}

@Directive({
    selector: 'th[sortable]',
    host: {
        '[class.asc]': 'direction === "asc"',
        '[class.desc]': 'direction === "desc"',
        '(click)': 'rotate()'
    },
    standalone: false
})
export class NgbdSortableHeader {

  @Input() sortable: SortColumn = '';
  @Input() direction: SortDirection = '';
  @Output() sort = new EventEmitter<SortEvent>();

  rotate() {
    this.direction = rotate[this.direction];
    this.sort.emit({column: this.sortable, direction: this.direction});
  }
}


@Component({
    selector: 'app-entry-list',
    templateUrl: './entry-list.component.html',
    styleUrls: ['./entry-list.component.scss'],
    standalone: false
})
export class EntryListComponent implements OnInit, OnDestroy {

  entryDetail = '/'+Navigation.EntryDetail;
  @Input() entries: Observable<any[]>;
  private _sub: Subscription;
  test: Entry[];
  private auth = inject(Auth);
  signedIn = false;
  currentUser = null;
  private authSubscription?;
  constructor(
    private _entryService: EntryService,
  ) {
    this.authSubscription = onAuthStateChanged(this.auth, (user) => {
      if (user) {
        // User is signed in, see docs for a list of available properties
        // https://firebase.google.com/docs/reference/js/auth.user
        this.currentUser = user;
        this.signedIn = true;
        // ...
      } else {
        // User is signed out
        this.currentUser = null;
        this.signedIn = false;
      }
    });
  }
  ngOnDestroy(): void {
    if(this.authSubscription) {
      // unsubscribes
      this.authSubscription();
    }
    if(this._sub) {
      this._sub.unsubscribe();
    }
  }
  ngOnInit(): void {
    this._sub = this.entries.subscribe(x => this.test = x);
  }

  @ViewChildren(NgbdSortableHeader) headers: QueryList<NgbdSortableHeader>;

  onSort({column, direction}: SortEvent) {
    // resetting other headers
    this.headers.forEach(header => {
      if (header.sortable !== column) {
        header.direction = '';
      }
    });
    // sorting countries
    if (direction === '' || column === '') {
      this.test = this.test;
    } else {
      this.test = [...this.test].sort((a, b) => {
        const res = compare(a[column], b[column]);
        return direction === 'asc' ? res : -res;
      });
    }
  }
  markStart(entryId: string){
    this._entryService.startEntries(null, [entryId]);
  }
  markFinished(entryId: string){
    this._entryService.finishEntries([entryId]);
  }

}
